import React, { FunctionComponent } from "react";

const CalendarIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/interface-essential/date-calendar/calendar
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-0.25 -0.25 24.5 24.5">
      <defs></defs>
      <title>calendar</title>
      <rect
        x="0.752"
        y="3.75"
        width="22.5"
        height="19.5"
        rx="1.5"
        ry="1.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></rect>
      <line
        x1="0.752"
        y1="9.75"
        x2="23.252"
        y2="9.75"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
      <line
        x1="6.752"
        y1="6"
        x2="6.752"
        y2="0.75"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
      <line
        x1="17.252"
        y1="6"
        x2="17.252"
        y2="0.75"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
    </svg>
  );
};

export default CalendarIcon;
